import React from 'react';

/**
 * Hidden honeypot field. Bots auto-filling every input will populate it;
 * humans never see it (CSS off-screen, tabindex=-1, aria-hidden).
 */
const HoneypotField = ({ value, onChange }) => (
  <div
    aria-hidden="true"
    style={{
      position: 'absolute',
      left: '-9999px',
      width: '1px',
      height: '1px',
      overflow: 'hidden',
    }}
  >
    <label htmlFor="website">Leave this field empty</label>
    <input
      id="website"
      name="website"
      type="text"
      tabIndex={-1}
      autoComplete="off"
      value={value || ''}
      onChange={onChange}
    />
  </div>
);

export default HoneypotField;
